import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  alpha,
  useTheme,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  AutoAwesome as AutoAwesomeIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Notifications as NotificationsIcon,
  Checklist as ChecklistIcon,
  TaskAlt as TaskAltIcon,
} from "@mui/icons-material";
import SupportLayout from "../Support/SupportLayout";

const AutomateTurnovers = () => {
  const theme = useTheme();

  const steps = [
    { label: "Connect Calendar", desc: "Sync your Airbnb/Vrbo calendar" },
    { label: "Auto-Create Jobs", desc: "Cleanings scheduled automatically" },
    { label: "Send Reminders", desc: "Cleaners get notified instantly" },
    { label: "Track Completion", desc: "Photo verification and reports" },
  ];

  const benefits = [
    { icon: <AutoAwesomeIcon />, title: "Auto-Create Jobs", desc: "Cleanings are created automatically from guest bookings" },
    { icon: <NotificationsIcon />, title: "Smart Reminders", desc: "Cleaners receive automatic notifications" },
    { icon: <TaskAltIcon />, title: "Prevent Missed Cleanings", desc: "Never forget a turnover again" },
    { icon: <ChecklistIcon />, title: "Digital Checklists", desc: "Ensure quality with photo verification" },
    { icon: <ScheduleIcon />, title: "Reduce Turnover Stress", desc: "Focus on your guests, not the schedule" },
  ];

  return (
    <SupportLayout
      title="Automate Every Airbnb Turnover"
      category="Services"
      subtitle="FreshSweeper automatically creates cleaning jobs from bookings, sends reminders, and tracks completion so your next guest arrives to a spotless property."
      breadcrumbs={[
        { label: "Services", link: "/services" },
        { label: "Automate Turnovers" },
      ]}
    >
      {/* How It Works */}
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" fontWeight="700" textAlign="center" gutterBottom>
          How Automation Works
        </Typography>
        <Stepper alternativeLabel sx={{ mt: 4, mb: 4 }}>
          {steps.map((step, idx) => (
            <Step key={idx}>
              <StepLabel>
                <Typography variant="body2" fontWeight="600">{step.label}</Typography>
                <Typography variant="caption" color="text.secondary">{step.desc}</Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>

      {/* Benefits */}
      <Grid container spacing={4} sx={{ mb: 6 }}>
        {benefits.map((benefit, idx) => (
          <Grid item xs={12} md={4} key={idx}>
            <Card sx={{ height: "100%", p: 3, borderRadius: 3 }}>
              <Box sx={{ color: theme.palette.primary.main, mb: 2 }}>
                {React.cloneElement(benefit.icon, { sx: { fontSize: 40 } })}
              </Box>
              <Typography variant="h6" fontWeight="700" gutterBottom>
                {benefit.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {benefit.desc}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ textAlign: "center", py: 4 }}>
        <Button
          variant="contained"
          size="large"
          startIcon={<AutoAwesomeIcon />}
          sx={{ borderRadius: "50px", px: 5, py: 1.5 }}
        >
          Automate My Cleanings
        </Button>
      </Box>
    </SupportLayout>
  );
};

export default AutomateTurnovers;